// Production · carte À PRÉPARER (LOT 7 §1) — toute commande validée entre ici
// automatiquement. Détail INCONDITIONNEL (§5) : nom + qty par ligne, modifs +
// note rattachées à SA pizza. [ Commencer ] = transition commandee→priorisee via
// le gate (INV-B — aucune logique de transition ici), FACULTATIF : la commande
// reste visible et comptée sans lui. Bouton MAISON (zéro animation Production).
// Jamais le téléphone (RGPD §8).
import { nomAffichage } from '@/lib/affichage-commande';
import { parseNotes } from '@/lib/notes-convention';
import { formatHeure, formatMod } from '@/lib/format';
import { NOTE_MAX_TUILE, NotePizza } from '@/screens/shared/NotePizza';
import { StatutDelai } from '@/screens/shared/StatutDelai';
import type { StatutDelai as StatutDelaiMoteur } from '@/lib/heure-capacite';
import type { TuileT2 } from '@/hooks/useT2File';

interface Props {
  tuile: TuileT2;
  nomParId: Map<number, string>;
  numeros: ReadonlyMap<number, number>;
  delai: StatutDelaiMoteur | undefined;
  onCommencer: (commandeId: number) => void;
}

export function CarteAPreparer({ tuile, nomParId, numeros, delai, onCommencer }: Props) {
  const { commande, lignes } = tuile;
  const id = commande.id as number;
  return (
    <div
      data-testid="carte-a-preparer"
      className="flex flex-col gap-3 rounded-lg border-2 border-ardoise bg-card p-4"
    >
      <div className="flex items-baseline justify-between gap-3">
        <span
          className={
            commande.client_nom_snapshot
              ? 'font-cormorant text-3xl italic'
              : 'font-jost text-2xl font-medium'
          }
        >
          {nomAffichage(commande, numeros)}
        </span>
        <span className="font-mono text-2xl">
          {formatHeure(commande.heure_retrait_proposee)}
        </span>
      </div>
      <StatutDelai delai={delai} className="text-xl" />

      <div className="flex flex-col gap-1">
        {lignes.map((l) => {
          const parsed = parseNotes(l.notes_libres ?? '');
          return (
            <div key={l.id} className="flex flex-wrap items-baseline gap-2">
              <span className="font-jost text-2xl font-bold">
                {l.qty}× {nomParId.get(l.pizzaId) ?? `Pizza #${l.pizzaId}`}
              </span>
              {parsed.mod.map((m, i) => (
                <span
                  key={`${m}-${i}`}
                  className="rounded bg-rose px-2 py-0.5 font-jost text-lg text-ardoise"
                >
                  {formatMod(m)}
                </span>
              ))}
              <NotePizza texte={parsed.texte} max={NOTE_MAX_TUILE} />
            </div>
          );
        })}
      </div>

      <button
        type="button"
        onClick={() => onCommencer(id)}
        className="min-h-[80px] rounded-lg bg-ardoise font-jost text-2xl text-creme"
      >
        Commencer
      </button>
    </div>
  );
}
